// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UXZY","footer":"styles_footer__1V54F"};